<template>
    <div v-if="!isCurrencySelectorHidden">
        <div v-show="ready">
        <div v-if="!isMobile">
            <div class="relative inline-flex items-center" ref="rootRef">
                <button
                    type="button"
                    @click.stop="open = !open"
                    class="inline-flex w-full items-center rounded-xl border border-gray-200 bg-gray-50/80 px-6 py-2 text-sm font-semibold text-gray-700 shadow-sm transition-all hover:border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-czech-blue/20 focus:ring-offset-1"
                    :aria-expanded="open"
                    aria-haspopup="listbox"
                >
<!--                    <span class="flex-1 text-left">-->
<!--                        {{ currentCurrency?.code || '' }}-->
<!--                    </span>-->

<!--                    <span class="h-5 w-5 flex items-center justify-center text-sm leading-none flex-shrink-0">-->
<!--                        {{ currentCurrency?.symbol || '' }}-->
<!--                    </span>-->
                    <div class="flex items-center gap-2 flex-1 text-left">
                        <span>
                            {{ currentCurrency?.code || '' }}
                        </span>

                        <span class="text-sm">
                            {{ currentCurrency?.symbol || '' }}
                        </span>
                    </div>

                    <svg
                        class="h-4 w-4 text-gray-500 flex-shrink-0 ml-auto transition-transform duration-200"
                        :class="{ 'rotate-180': open }"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                <Transition
                    enter-active-class="transition ease-out duration-100"
                    enter-from-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                >
                    <div
                        v-show="open"
                        class="absolute top-full right-0 z-50 mt-2 w-[21rem] origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black/5 overflow-hidden"
                    >
                        <div class="px-4 py-3 bg-white">
                            <p class="text-sm font-semibold text-gray-800">
                                {{ texts['currency-select-key'] ?? null }}
                            </p>
                        </div>

                        <div class="h-px bg-gray-200"></div>

                        <div class="p-3 grid grid-cols-3 gap-2">
                            <button
                                v-for="currency in currencies"
                                :key="currency.code"
                                @click="selectCurrency(currency)"
                                class="flex items-center w-full px-3 py-3 rounded-[12px] text-sm transition-all duration-200"
                                :class="isCurrentCurrency(currency.code)
        ? 'bg-gray-100 text-gray-900 font-semibold'
        : 'text-gray-700 bg-gray-50'"
                            >
                                <!-- LEFT -->
                                <div class="flex flex-1 items-center gap-1 min-w-0">
        <span class="font-medium truncate">
            {{ currency.code }}
        </span>

                                    <span class="text-sm font-bold text-gray-500 shrink-0">
            {{ currency.symbol }}
        </span>
                                </div>

                                <!-- CHECK -->
                                <svg
                                    v-if="isCurrentCurrency(currency.code)"
                                    class="w-4 h-4 ml-2 flex-shrink-0 text-gray-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.515 3.515 6.364-6.364a1 1 0 011.414 0z"
                                          clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                        <div class="bg-blue-800 px-3 py-3 flex items-center justify-between">
                            <button
                                type="button"
                                @click="open = false"
                                class="bg-red-500 hover:bg-red-600 text-white text-xs font-semibold px-3 py-1.5 rounded-[12px] transition"
                            >
                                {{ texts['currency-select-key-2'] ?? null }}
                            </button>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
        <div v-else>
            <div class="relative flex w-full" ref="rootRef">
                <button
                    type="button"
                    @click.stop="open = !open"
                    class="w-full inline-flex items-center gap-2.5 rounded-xl border border-gray-200 bg-gray-50/80 px-3.5 py-2 text-sm font-semibold text-gray-700 shadow-sm transition-all hover:border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-czech-blue/20 focus:ring-offset-1"
                    :aria-expanded="open"
                    aria-haspopup="listbox"
                >
                    <span class="h-5 w-5 flex items-center justify-center text-sm leading-none flex-shrink-0">
                        {{ currentCurrency?.symbol || '' }}
                    </span>

                    <span class="flex-1 text-left leading-none">
                        {{ currentCurrency?.code || 'EUR' }}
                    </span>

                    <svg
                        class="h-4 w-4 text-gray-500 transition-transform duration-200 ml-auto flex-shrink-0"
                        :class="{ 'rotate-180': open }"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                <Transition name="fade">
                    <div
                        v-show="open"
                        class="fixed inset-0 z-[80] bg-black/40"
                        @click="open = false"
                    />
                </Transition>

                <Transition name="slide-down">
                    <div
                        v-show="open"
                        class="fixed top-0 left-0 right-0 z-[90] bg-white rounded-b-2xl shadow-xl overflow-hidden"
                    >

                        <!-- HEADER -->
                        <div class="flex items-center justify-between px-4 py-4 border-b">
                            <p class="text-base font-semibold text-gray-800">
                                {{ texts['currency-select-key'] ?? null }}
                            </p>

                            <button @click="open = false" class="p-2">
                                <svg class="w-5 h-5 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path stroke-width="2" d="M6 6l12 12M6 18L18 6"/>
                                </svg>
                            </button>
                        </div>

                        <!-- BODY -->
                        <div class="p-4 grid grid-cols-3 gap-3">
                            <button
                                v-for="currency in currencies"
                                :key="currency.code"
                                @click="selectCurrency(currency)"
                                class="flex items-center justify-between px-4 py-3 rounded-xl text-sm w-full transition"
                                :class="isCurrentCurrency(currency.code)
                                ? 'bg-gray-100 text-gray-900 font-semibold'
                                : 'text-gray-700 bg-gray-50'"
                            >
                                <span class="truncate font-medium">
                                    {{ currency.code }}
                                </span>

                                                <span class="font-bold">
                                    {{ currency.symbol }}
                                </span>

                                <svg
                                    v-if="isCurrentCurrency(currency.code)"
                                    class="w-4 h-4 ml-auto text-gray-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.515 3.515 6.364-6.364a1 1 0 011.414 0z"
                                          clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>

                        <!-- FOOTER -->
                        <div class="p-4 border-t">
                            <button
                                @click="open = false"
                                class="w-full bg-red-500 text-white py-3 rounded-xl font-semibold"
                            >
                                {{ texts['currency-select-key-2'] ?? null }}
                            </button>
                        </div>

                    </div>
                </Transition>
            </div>
        </div>
        </div>
        <div v-show="!ready">
            <slot />
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'SelectAppCurrency',
    setup() {
        const store = useStore();
        const open = ref(false);
        const ready = ref(false);
        const rootRef = ref(null);

        const isCurrencySelectorHidden = computed(() => store.getters['currency/isCurrencySelectorHidden']);
        const isLockedToEuro = computed(() => store.getters['currency/isLockedToEuro']);

        const currencies = computed(() => {
            const list = store.getters.currencies || [];
            if (!isLockedToEuro.value) {
                return list;
            }
            return list.filter((item) => String(item?.code ?? '').trim().toUpperCase() === 'EUR');
        });

        const currentCurrency = computed(() => {
            return store.getters['currency/currentCurrency'] || currencies.value[0] || {};
        });

        const texts = computed(() => {
            return store.getters.texts || {};
        });

        const isMobile = computed(() => {
            return store.getters.mobileView || false;
        });

        function isCurrentCurrency(code) {
            return code?.toLowerCase() === currentCurrency.value?.code?.toLowerCase();
        }

        function selectCurrency(currency) {
            if (isLockedToEuro.value) {
                return;
            }
            open.value = false;

            if (typeof window.switchCurrency === 'function') {
                window.switchCurrency(currency?.code);
                return;
            }
            store.dispatch('currency/setCurrencyByCode', currency?.code);
        }

        function onOutsideClick(e) {
            if (rootRef.value && !rootRef.value.contains(e.target)) {
                open.value = false;
            }
        }

        onMounted(() => {
            ready.value = true;
            document.addEventListener('click', onOutsideClick);
        });


        onBeforeUnmount(() => {
            document.removeEventListener('click', onOutsideClick);
        });

        return {
            open,
            ready,
            rootRef,
            currencies,
            currentCurrency,
            selectCurrency,
            isCurrentCurrency,
            isCurrencySelectorHidden,
            isLockedToEuro,
            isMobile,
            texts
        };
    }
};
</script>
<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.25s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave-from {
    transform: translateY(0);
    opacity: 1;
}
</style>
